export const getAdBlockerStatus = state => state.adBlocker;
export const hasAdBlocker = state => getAdBlockerStatus(state).adBlockerDetected;



// WEBPACK FOOTER //
// ./src/selectors/adBlocker.js